import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { Button, Container, Divider, Header, Menu } from 'semantic-ui-react'

import ReportCaseSummarySection from './sections/ReportCaseSummarySection'
import ReportCaseIntakeSection from './sections/ReportCaseIntakeSection'
import ReportCaseDeliverySigningSection from './sections/ReportCaseDeliverySigningSection'
import ReportCasePaymentSection from './sections/ReportCasePaymentSection'
// import ReportCaseMilestonesSection from './sections/ReportCaseMilestonesSection'
// import ReportCaseDocumentsReturnSection from './sections/ReportCaseDocumentsReturnSection'
import ReportCaseCommentsSection from './sections/ReportCaseCommentsSection'
import { deriveReportCaseStatus } from '../../../utilities/reportCaseStatus'

class ViewReportCase extends Component {
    constructor(props) {
        super(props)

        const r = props.reportCaseToView || {}

        this.state = {
            activeItem: 'summary',

            // Core
            companyName: r.companyName || '',
            status: r.status || 'pending_assign',
            companySecretary: r.companySecretary || '',
            taxAgent: r.taxAgent || '',

            // Intake
            emailReceivedOn: r.emailReceivedOn || '',
            personInCharge: normalizeId(r.personInCharge),
            reportTypes: r.reportTypes || [],
            xbrlService: !!r.xbrlService,
            fye: r.fye || '',
            instructions: r.instructions || '',

            // Deadlines / follow-up
            dueDate: r.dueDate || '',
            nextFollowUpDate: r.nextFollowUpDate || '',
            isUrgent: r.isUrgent || '',

            // Delivery & signing
            sentToClientDate: r.sentToClientDate || '',
            deliveryMethod: r.deliveryMethod || '',
            courierCompany: r.courierCompany || '',
            deliverySigningStatus: r.deliverySigningStatus || '',
            deliverySigningRemarks: r.deliverySigningRemarks || '',
            signedReceivedDate: r.signedReceivedDate || '',

            // Payment
            totalOutstanding: r.totalOutstanding ?? '',
            paymentRemark: r.paymentRemark || '',
            workflowCompleted: r.workflowCompleted || false,

            // Release / admin
            bindingReleasedOn: r.bindingReleasedOn || '',
            acraFilingReleasedOn: r.acraFilingReleasedOn || '',
            irasFilingReleasedOn: r.irasFilingReleasedOn || '',
            emailedAdjOn: r.emailedAdjOn || '',
            emailedClientProfilePageOn: r.emailedClientProfilePageOn || '',

            // Documents return
            documentsReturnStatus: r.documentsReturnStatus || 'not_required',
            documentsReturnedOn: r.documentsReturnedOn || '',
            incompleteDocsRemark: r.incompleteDocsRemark || '',

            // Milestones
            milestones: r.milestones || [],

            // Comments
            newComment: ''
        }
    }

    componentDidMount() {
        this.props.fetchReportCaseAssignees()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reportCaseToView !== this.props.reportCaseToView) {
            const r = this.props.reportCaseToView || {}
            this.setState({
                companyName: r.companyName || '',
                status: r.status || 'pending_assign',
                companySecretary: r.companySecretary || '',
                taxAgent: r.taxAgent || '',
                emailReceivedOn: r.emailReceivedOn || '',
                personInCharge: normalizeId(r.personInCharge),
                reportTypes: r.reportTypes || [],
                xbrlService: !!r.xbrlService,
                fye: r.fye || '',
                instructions: r.instructions || '',
                dueDate: r.dueDate || '',
                nextFollowUpDate: r.nextFollowUpDate || '',
                isUrgent: r.isUrgent || '',
                sentToClientDate: r.sentToClientDate || '',
                deliveryMethod: r.deliveryMethod || '',
                courierCompany: r.courierCompany || '',
                deliverySigningStatus: r.deliverySigningStatus || '',
                deliverySigningRemarks: r.deliverySigningRemarks || '',
                signedReceivedDate: r.signedReceivedDate || '',
                totalOutstanding: r.totalOutstanding ?? '',
                paymentRemark: r.paymentRemark || '',
                bindingReleasedOn: r.bindingReleasedOn || '',
                acraFilingReleasedOn: r.acraFilingReleasedOn || '',
                irasFilingReleasedOn: r.irasFilingReleasedOn || '',
                emailedAdjOn: r.emailedAdjOn || '',
                emailedClientProfilePageOn: r.emailedClientProfilePageOn || '',
                documentsReturnStatus: r.documentsReturnStatus || 'not_required',
                documentsReturnedOn: r.documentsReturnedOn || '',
                incompleteDocsRemark: r.incompleteDocsRemark || '',
                milestones: r.milestones || [],
                newComment: '',
                activeItem: 'summary'
            })
        }
    }

    setField = (field, value) => {
        this.setState({ [field]: value })
    }

    setMilestones = (milestones) => {
        this.setState({ milestones })
    }

    handleMenuItemClicked = (e, { name }) => {
        this.setState({ activeItem: name })
    }

    handleSave = async () => {
        const id = this.props.reportCaseToView?._id
        if (!id) return

        const nextStatus = deriveReportCaseStatus(this.state.status, {
            workflowCompleted: this.state.workflowCompleted,
            personInCharge: this.state.personInCharge,
            sentToClientDate: this.state.sentToClientDate,
            signedReceivedDate: this.state.signedReceivedDate,
            totalOutstanding: this.state.totalOutstanding
        })

        const payload = {
            companyName: this.state.companyName,
            status: nextStatus,
            companySecretary: this.state.companySecretary || '',
            taxAgent: this.state.taxAgent || '',

            emailReceivedOn: emptyToNull(this.state.emailReceivedOn),
            personInCharge: emptyToNull(this.state.personInCharge),
            reportTypes: this.state.reportTypes,
            xbrlService: !!this.state.xbrlService,
            fye: this.state.fye,
            instructions: this.state.instructions,

            dueDate: emptyToNull(this.state.dueDate),
            nextFollowUpDate: emptyToNull(this.state.nextFollowUpDate),
            isUrgent: emptyToNull(this.state.isUrgent),

            sentToClientDate: emptyToNull(this.state.sentToClientDate),
            deliveryMethod: this.state.deliveryMethod || undefined,
            courierCompany: this.state.courierCompany,

            deliverySigningStatus: this.state.deliverySigningStatus || '',
            deliverySigningRemarks: this.state.deliverySigningRemarks || '',

            signedReceivedDate: emptyToNull(this.state.signedReceivedDate),

            totalOutstanding: toNumberOrNull(this.state.totalOutstanding),
            paymentRemark: this.state.paymentRemark,
            workflowCompleted: !!this.state.workflowCompleted,

            bindingReleasedOn: emptyToNull(this.state.bindingReleasedOn),
            acraFilingReleasedOn: emptyToNull(this.state.acraFilingReleasedOn),
            irasFilingReleasedOn: emptyToNull(this.state.irasFilingReleasedOn),
            emailedAdjOn: emptyToNull(this.state.emailedAdjOn),
            emailedClientProfilePageOn: emptyToNull(this.state.emailedClientProfilePageOn),

            documentsReturnStatus: this.state.documentsReturnStatus,
            documentsReturnedOn: emptyToNull(this.state.documentsReturnedOn),
            incompleteDocsRemark: this.state.incompleteDocsRemark,

            milestones: this.state.milestones
        }

        await this.props.updateReportCase(id, payload)
        if (this.props.onEditSuccess) this.props.onEditSuccess()
    }

    handleAddComment = async () => {
        const id = this.props.reportCaseToView?._id
        if (!id) return

        const message = (this.state.newComment || '').trim()
        if (!message) return

        await this.props.addReportCaseComment(id, message)
        this.setState({ newComment: '' })
    }

    renderContent() {
        const r = this.props.reportCaseToView
        if (!r) return null

        switch (this.state.activeItem) {
            case 'summary':
                return (
                    <ReportCaseSummarySection
                        values={this.state}
                        onChange={this.setField}
                        onSave={this.handleSave}
                    />
                )
            case 'intake':
                return (
                    <ReportCaseIntakeSection
                        values={this.state}
                        users={this.props.reportCaseAssignees}
                        onChange={this.setField}
                    />
                )
            case 'delivery':
                return (
                    <ReportCaseDeliverySigningSection
                        values={this.state}
                        onChange={this.setField}
                    />
                )
            case 'payment':
                return (
                    <ReportCasePaymentSection
                        values={this.state}
                        onChange={this.setField}
                    />
                )
            // case 'milestones':
            //     return (
            //         <ReportCaseMilestonesSection
            //             milestones={this.state.milestones}
            //             onChangeMilestones={this.setMilestones}
            //         />
            //     )
            // case 'docsReturn':
            //     return (
            //         <ReportCaseDocumentsReturnSection
            //             values={this.state}
            //             onChange={this.setField}
            //         />
            //     )
            case 'comments':
                return (
                    <ReportCaseCommentsSection
                        reportCase={r}
                        newComment={this.state.newComment}
                        onChangeNewComment={(v) => this.setField('newComment', v)}
                        onAddComment={this.handleAddComment}
                    />
                )
            default:
                return null
        }
    }

    render() {
        const r = this.props.reportCaseToView
        if (!r) return null

        return (
            <Container style={{ paddingTop: 20, paddingBottom: 60 }}>
                <Button basic onClick={this.props.onBackClicked}>Back</Button>

                <Header as='h2' style={{ marginTop: 10 }}>
                    Workflow – {this.state.companyName || 'Untitled'}
                </Header>

                <Menu tabular stackable>
                    <Menu.Item name='summary' active={this.state.activeItem === 'summary'} onClick={this.handleMenuItemClicked}>
                        Summary
                    </Menu.Item>
                    <Menu.Item name='intake' active={this.state.activeItem === 'intake'} onClick={this.handleMenuItemClicked}>
                        Intake
                    </Menu.Item>
                    <Menu.Item name='delivery' active={this.state.activeItem === 'delivery'} onClick={this.handleMenuItemClicked}>
                        Delivery & Signing
                    </Menu.Item>
                    <Menu.Item name='payment' active={this.state.activeItem === 'payment'} onClick={this.handleMenuItemClicked}>
                        Payment
                    </Menu.Item>
                    {/* <Menu.Item name='milestones' active={this.state.activeItem === 'milestones'} onClick={this.handleMenuItemClicked}>
                        Milestones
                    </Menu.Item>
                    <Menu.Item name='docsReturn' active={this.state.activeItem === 'docsReturn'} onClick={this.handleMenuItemClicked}>
                        Docs Return
                    </Menu.Item> */}
                    <Menu.Item name='comments' active={this.state.activeItem === 'comments'} onClick={this.handleMenuItemClicked}>
                        Comments
                    </Menu.Item>
                </Menu>

                <Divider hidden />

                {this.renderContent()}

                <Divider />

                <Button primary onClick={this.handleSave}>Save Changes</Button>
            </Container>
        )
    }
}

function normalizeId(v) {
    if (!v) return ''
    if (typeof v === 'string') return v
    if (v._id) return v._id
    return ''
}

function emptyToNull(v) {
    if (v === '') return null
    return v
}

function toNumberOrNull(v) {
    if (v === '' || v == null) return null
    const n = Number(v)
    return Number.isFinite(n) ? n : null
}

function mapStateToProps({ reportCaseAssignees }) {
    return { reportCaseAssignees }
}

export default connect(mapStateToProps, actions)(ViewReportCase)
